import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
interface ActionProgressProps {
  current: number;
  total: number;
  type: string;
}
export const ActionProgress: FC<ActionProgressProps> = t0 => {
  const $ = _c(11);
  const {
    current,
    total,
    type
  } = t0;
  const percentage = current / total * 100;
  let t1;
  if ($[0] !== type) {
    t1 = () => {
      switch (type) {
        case "quiz":
          {
            return "questions answered";
          }
        case "challenge":
          {
            return "tasks completed";
          }
        case "poll":
          {
            return "votes counted";
          }
        default:
          {
            return "completed";
          }
      }
    };
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getProgressText = t1;
  const t2 = `${percentage}%`;
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="absolute bg-[#1a54d6] left-0 top-0 bottom-0" style={{
      width: t2
    }} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = getProgressText();
  let t5;
  if ($[4] !== current || $[5] !== t4 || $[6] !== total) {
    t5 = <div className="relative z-10 font-['Inter'] font-semibold text-[14px] text-[#e9ecf0] leading-none">{current}/{total} {t4}</div>;
    $[4] = current;
    $[5] = t4;
    $[6] = total;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="relative rounded-[100px] w-full bg-[#000000] px-4 py-2 overflow-hidden">{t3}{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};